import * as a from "react";
const l = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M5.694 11.502l6.374-5.298a.34.34 0 01.44 0l6.374 5.298a1.027 1.027 0 001.459-.156 1.076 1.076 0 00-.149-1.495l-6.374-5.305a2.415 2.415 0 00-3.06 0L4.383 9.851a1.076 1.076 0 00.161 1.757 1.027 1.027 0 001.15-.106z",
      fill: "#333"
    }
  ),
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M19.603 19.584v-4.958a1.572 1.572 0 00-.517-1.126l-5.878-4.958a1.374 1.374 0 00-1.771 0L5.558 13.5a1.572 1.572 0 00-.517 1.126v4.958a1.417 1.417 0 001.417 1.417h3.782a.708.708 0 00.708-.709v-3.895a.708.708 0 01.708-.708h1.417a.708.708 0 01.708.708v3.896a.708.708 0 00.709.708h3.81a1.417 1.417 0 001.303-1.417z",
      fill: "#333"
    }
  )
);
export {
  l as default
};
